import { Component, OnInit } from '@angular/core'

import { UserService } from '../services/user.service'
import { FavouriteService } from '../services/favourite.service'

@Component({
    selector: 'app-favourites',
    templateUrl: './favourites.component.html'
})
export class FavouritesPageComponent implements OnInit {
    favourites: Array<any> = []
    favouritesLoading: Boolean = true
    currentUser: any

    constructor(
        private userService: UserService,
        private favouriteService: FavouriteService,
    ) {
    }

    ngOnInit() {
        this.userService.getCurrentUser()
        this.userService.currentUser.subscribe((currentUser) => {
            this.currentUser = currentUser
            if (this.currentUser && this.currentUser.favourites && this.currentUser.favourites.length > 0) {
                this.getFavourites()
            } else if (this.currentUser && this.currentUser.favourites && this.currentUser.favourites.length === 0) {
                this.favouritesLoading = false
            }
        })
    }

    getFavourites() {
        this.favouriteService.getFavourites(this.currentUser.favourites)
        this.favouriteService.Favourites.subscribe(favourites => {
            if (favourites && favourites.favourites) {
                this.favouritesLoading = false
                this.favourites = favourites.favourites.map(elm => {
                    let newElm = {
                        courseId: elm.course._id,
                        courseCode: elm.course.courseCode,
                        courseName: elm.course.name,
                        courseSlug: elm.course.slug,
                        providerId: elm.provider._id,
                        providerName: elm.provider.name,
                        providerSlug: elm.provider.slug,
                        reviewsCount: 0,
                        studentScore: 'N/A',
                        employerScore: 'N/A',
                        distance: 0,
                        location: elm.provider.location
                    }
                    let reviews = favourites.reviews.filter(item => item.course === elm.course._id && item.provider === elm.provider._id)
                    if (reviews && reviews.length > 0) {
                        newElm.reviewsCount = reviews.length
                        let employer = reviews.filter(item => item.userType === 'Employer')
                        if (employer.length > 0) {
                            employer = employer.map(item => item.score)
                            newElm.employerScore = (employer.reduce((sum, elm) => sum + elm) / employer.length).toString()
                        }
                        let student = reviews.filter(item => item.userType === 'Student')
                        if (student.length > 0) {
                            student = student.map(item => item.score)
                            newElm.studentScore = (student.reduce((sum, elm) => sum + elm) / student.length).toString()
                            let numStr = newElm.studentScore + ''
                            if (numStr.indexOf('.') !== -1) {
                                newElm.studentScore = parseFloat(newElm.studentScore).toFixed(1)
                            }
                        }
                    }
                    return newElm
                })
                this.getLocation()
            }
        })
    }

    getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.favourites = this.favourites.map(item => {
                    const newItem = item
                    if (item.location && item.location.Latitude && item.location.Longitude) {
                        newItem.distance = this.calcDistance(position.coords.latitude, position.coords.longitude, item.location.Latitude, item.location.Longitude)
                    }
                    return newItem
                });
            });
        }
    }

    calcDistance(lat1, lon1, lat2, lon2) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            let radlat1 = Math.PI * lat1 / 180;
            let radlat2 = Math.PI * lat2 / 180;
            let theta = lon1 - lon2;
            let radtheta = Math.PI * theta / 180;
            let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344
            return dist.toFixed(0);
        }
    }

    removeFavourite(item) {
        const body = {
            action: 'remove',
            userId: this.currentUser._id,
            courseId: item.courseId,
            providerId: item.providerId
        }
        this.userService.addOrRemoveFavourite(body).then(result => {
            this.favourites = this.favourites.filter(elm => !(elm.courseId === body.courseId && elm.providerId === body.providerId ))
        }).catch(error => {
            console.log(error);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/user/favourites.component.ts